import { axios } from '@Root/API'

export const resyncSubmission = id => {
  return axios.post(`cognito-submissions/${id}/resync`)
}
